"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/* ++++++++++ --------------- LOADER : DEFINITION --------------- ++++++++++ */

var _default = {
  name: 'Loader',
  props: {}
};
exports.default = _default;